module.exports = __webpack_public_path__ + "img/lto.68260ef7.svg";